<template>
  <FormItem :label="label" :required="!!required">
    <template v-if="editable">
    <RadioGroup :value="strValue" @input="$emit('input',$event)">
      <div class="flex-wrap" style="flex-wrap:wrap;gap:5px">
      <template v-for="o in options">
          <Radio :label="o.key" :key="o.key" :disabled="!editable" :border="config.border" style="margin-right:40px;">
            <Icon v-if="o.icon" :type="o.icon"></Icon>
            <span>{{o.name}}</span>
        </Radio>
      </template>
      </div>
    </RadioGroup>
  </template>
    <template v-else>
      <div>{{val_objects}}</div>
    </template>
 </FormItem>
</template>

<script>
import defaultValueMixin from '../mixins/default-value';
export default {
  mixins: [defaultValueMixin],
  cname: '单选框',
  icon: 'danxuan',
  corder: 40,
  properties: [{
    label: '选项',
    key: 'options',
    control: 'SelectOption',
  }, {
    label: '简易选项',
    key: 'simple',
    control: 'Check',
  }, {
    label: '边框',
    key: 'border',
    control: 'Check',
  }, {
    label: 'URL',
    key: 'url',
    control: 'Text',
  }],
  props: ['fkey', 'config', 'value', 'editable', 'label', 'required'],
  initModel(e) {
    if (!e.config || !e.config.options) {
      e.config = {
        border: false,
        simple: true,
        options: ['选项1', '选项2'],
        url: '',
      };
    } else {
      e.config = {
        options: e.config.options || ['选项1', '选项2'],
        url: e.config.url,
        border: e.config.border,
        simple: e.config.simple,
        multiple: e.config.multiple,
      };
    }
  },
  computed: {
    strValue() {
      if (this.value !== undefined) {
        const value = this.value || 0;
        return value.toString();
      }
    },
    val_objects() {
      return (this.options.find((t)=>t.key == v) || {}).name;
    },
    options() {
      let options = this.config.options;
      if (Array.isArray(options)) {
        if (options && typeof options[0] != 'object') {
          options = options.map((v, i)=>({
            key: i,
            name: v,
          }));
        }
      }
      if (this.config.simple) {
        options = options.map((v)=>({key: v.name, name: v.name}));
      }
      return options;
    },
  },
};
</script>

<style lang="less">
.l-full{
  position: relative;
  height:100%;
  width:100%;
}
</style>
